import React from 'react';
import { Typography, Card, Button, Space } from 'antd';
import { MailOutlined, SendOutlined, SettingOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const EmailManagement = () => {
  return (
    <div className="admin-module">
      <div className="admin-module-header">
        <Title level={3} className="admin-module-title">Email Management</Title>
        <Text className="admin-module-description">
          Manage email sending and template configuration
        </Text>
      </div>

      <Card>
        <div style={{ textAlign: 'center', padding: '40px 0' }}>
          <MailOutlined style={{ fontSize: '48px', color: '#13c2c2', marginBottom: '16px' }} />
          <Title level={4}>Email Management</Title>
          <Text type="secondary">This feature is under development, stay tuned...</Text>
          <br /><br />
          <Space>
            <Button type="primary" icon={<SendOutlined />}>Send Email</Button>
            <Button icon={<SettingOutlined />}>Email Settings</Button>
          </Space>
        </div>
      </Card>
    </div>
  );
};

export default EmailManagement; 